import { SerializedGame } from "@shared/types";

import { fetchGamesIds } from "./api/fetch-games-ids";

class RecommendationService {
  private gameIdList: Array<number> | undefined = [];
  public async fetchGames() {
    if (this.gameIdList?.length) return;
    const response = await fetchGamesIds();
    this.gameIdList = response?.games;
  }

  public sortedAllGames(
    games: Array<SerializedGame>
  ): Array<SerializedGame> | [] {
    if (!games) {
      return [];
    }

    return games.filter((game: SerializedGame) =>
      this.gameIdList?.includes(game.id)
    );
  }
}

export const recommendationService = new RecommendationService();
